export function SpeakVoiceIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M12.7003 6.7237C12.3195 3.77671 9.80061 1.5 6.74998 1.5C3.43627 1.5 0.749985 4.18629 0.749985 7.5C0.749985 8.9193 1.24279 10.2235 2.06661 11.2508C2.67262 12.0065 3.00023 12.8439 3.00017 13.7296L2.99998 16.5H9.74998L9.75074 14.25H11.25C12.0784 14.25 12.75 13.5784 12.75 12.75V10.5532L14.2195 9.92377C14.4769 9.81352 14.4993 9.55252 14.3881 9.37777L12.7003 6.7237ZM2.24998 7.5C2.24998 5.01472 4.2647 3 6.74998 3C9.01821 3 10.9249 4.68856 11.2126 6.91588L11.2554 7.24696L12.4123 9.06607L11.25 9.56392V12.75H8.25126L8.25051 15H4.50008L4.50017 13.7297C4.50025 12.5004 4.05722 11.3355 3.23682 10.3124C2.60112 9.51967 2.24998 8.53867 2.24998 7.5ZM15.8651 13.5768L14.617 12.7447C15.3327 11.6731 15.75 10.3853 15.75 9.00007C15.75 7.61475 15.3327 6.32692 14.617 5.25541L15.8651 4.42328C16.74 5.73289 17.25 7.3069 17.25 9.00007C17.25 10.6932 16.74 12.2671 15.8651 13.5768Z" fill="currentColor"
      />
    </svg>
  );
}

SpeakVoiceIcon.displayName = 'SpeakVoiceIcon';